import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import FlowView from '../views/Flow.vue'
import OrderView from '../views/Order.vue'
import IntelView from '../views/Intel.vue'
import RewardView from '../views/Reward.vue'
import InsightView from '../views/Insight.vue'
import landingDinamic from '../views/Landing.vue'
import landingTest from '../views/LandingTest.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/flow',
    name: 'flow',
    component: FlowView
  },
  {
    path: '/order',
    name: 'order',
    component: OrderView
  },
  {
    path: '/intel',
    name: 'intel',
    component: IntelView
  },
  {
    path: '/reward',
    name: 'reward',
    component: RewardView
  },
  {
    path: '/insight',
    name: 'insight',
    component: InsightView
  },
  {
    path: '/l/:id',
    name: 'landing',
    component: landingDinamic,
    meta: { transition: 'scale', mode: "out-in", requiresAuth: false, title: "Landing" },
  },
  {
    path: '/t/:id',
    name: 'landingTest',
    component: landingTest,
    meta: { transition: 'scale', mode: "out-in", requiresAuth: false, title: "Landing Test" },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
